module.exports = __webpack_public_path__ + "static/media/icon-instagram.7483ce07.svg";